import styled from 'styled-components';
import { DEFAULT_FONT, SECONDARY_COLOR } from '../../styles/variables';

export const FailureReasonText = styled.p`
  font-size: 0.8rem;
  padding-right: 12px;
  font-family: ${DEFAULT_FONT};
  max-width: 200px;
  max-height: 200px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${SECONDARY_COLOR};
    border-radius: 25px;
  }
`;

export const StatusTag = styled.div`
  color: ${props => props.color};
  background: ${props => props.backgroundColor};
  text-transform: capitalize;
  padding: 3px;
  font-size: 12px;
  letter-spacing: 1px;
  border-radius: 25px;
  width: 100px !important;
  text-align: center;
  .ant-badge {
    margin-right: -5px;
  }`;
